import Button from './Button'
import CallbackModal from './CallbackModal'
import Card from './Card'
import CheckableTreeView from './CheckableTreeView'
import CheckableTreeViewItem from './CheckableTreeViewItem'
import Checkbox from './Checkbox'
import CheckMark from './CheckMark'
import Child from './Child'
import DropDownSearch from './DropDownSearch'
import Evaluation from './Evaluation'
import EvaluationBadge from './EvaluationBadge'
import Evaluations from './Evaluations'
import FiveSelector from './FiveSelector'
import FormError from './FormError'
import Login from './Login'
import Logo from './Logo'
import TwoFactor from './TwoFactor'
import MaskDisplay from './MaskDisplay'
import MaskModal from './Masks/MaskModal'
import SaveSnapshotModal from './evaluation/SaveSnapshotModal'
import MasksSelector from './MasksSelector'
import OrganizationEditor from './OrganizationEditor'
import PaginationBlock from './PaginationBlock'
import ProfileDisplay from './ProfileDisplay'
import ProfilesSelector from './ProfilesSelector'
import RadarChart from './RadarChart'
import ReportDisplay from './ReportDisplay'
import ReportHeader from './ReportHeader'
import Reports from './Reports'
import Spinner from './Spinner'
import TreeView from './TreeView'
import TreeViewItem from './TreeViewItem'
import Vue from 'vue'
import VueAWN from 'vue-awesome-notifications'
import YesNoDetails from './YesNoDetails'
import LicensesModal from './LicensesModal'

import { HasError, AlertError, AlertSuccess } from 'vform'

// Components that are registered globally.
[
  TwoFactor,
  LicensesModal,
  AlertError,
  AlertSuccess,
  Button,
  CallbackModal,
  Card,
  CheckableTreeView,
  CheckableTreeViewItem,
  Checkbox,
  CheckMark,
  Child,
  DropDownSearch,
  Evaluation,
  EvaluationBadge,
  Evaluations,
  FiveSelector,
  FormError,
  HasError,
  Login,
  Logo,
  MaskDisplay,
  MaskModal,
  MasksSelector,
  OrganizationEditor,
  PaginationBlock,
  ProfileDisplay,
  ProfilesSelector,
  RadarChart,
  ReportDisplay,
  ReportHeader,
  Reports,
  SaveSnapshotModal,
  Spinner,
  TreeView,
  TreeViewItem,
  YesNoDetails,
  VueAWN
].forEach(Component => {
  Vue.component(Component.name, Component)
})



// WEBPACK FOOTER //
// ./resources/js/components/index.js